import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card card-custom" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "h6 mb-5 text-fprimary" }
const _hoisted_6 = { class: "table table-striped rounded w-100 border" }
const _hoisted_7 = { class: "p-2 text-center bg-info text-white" }
const _hoisted_8 = { class: "border p-2" }
const _hoisted_9 = { class: "border p-2" }
const _hoisted_10 = { class: "border p-2" }
const _hoisted_11 = { class: "border p-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { class: "border p-2" }, "Total", -1)
const _hoisted_13 = ["rowspan"]
const _hoisted_14 = { class: "border text-center" }
const _hoisted_15 = { class: "border text-center" }
const _hoisted_16 = {
  key: 1,
  class: "form-control form-control-solid w-100px py-1 border"
}
const _hoisted_17 = { class: "border text-center" }
const _hoisted_18 = {
  key: 1,
  class: "form-control form-control-solid w-100px py-1 border"
}
const _hoisted_19 = { class: "border text-center" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-sm-12" }
const _hoisted_22 = { class: "h6 mb-5 text-fprimary" }
const _hoisted_23 = { class: "table table-bordered w-100 border" }
const _hoisted_24 = { class: "text-center fw-bold" }
const _hoisted_25 = {
  rowspan: "2",
  colspan: "2",
  style: {"background-color":"#f8fdf8"}
}
const _hoisted_26 = {
  colspan: "3",
  class: "fw-bold",
  style: {"background-color":"#d6e8d6"}
}
const _hoisted_27 = { class: "text-center fw-bold" }
const _hoisted_28 = {
  class: "border",
  style: {"background-color":"#d6e8d6"}
}
const _hoisted_29 = {
  class: "border",
  style: {"background-color":"#d6e8d6"}
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("th", {
  class: "border",
  style: {"background-color":"#d6e8d6"}
}, "TOTAL", -1)
const _hoisted_31 = ["rowspan"]
const _hoisted_32 = { class: "border bg-success bg-opacity-10" }
const _hoisted_33 = { class: "border text-center" }
const _hoisted_34 = {
  key: 1,
  class: "form-control form-control-solid w-100px py-1 border"
}
const _hoisted_35 = { class: "border text-center" }
const _hoisted_36 = {
  key: 1,
  class: "form-control form-control-solid w-100px py-1 border"
}
const _hoisted_37 = { class: "border bg-success bg-opacity-10 text-center" }
const _hoisted_38 = { class: "bg-success bg-opacity-75 fw-bolder text-center" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("td", {
  class: "border text-end",
  colspan: "2"
}, [
  /*#__PURE__*/_createElementVNode("h6", { class: "" }, "Total de oficiales por deporte")
], -1)
const _hoisted_40 = { class: "border" }
const _hoisted_41 = { class: "border" }
const _hoisted_42 = { class: "border" }
const _hoisted_43 = {
  colspan: "2",
  class: "border text-end bg-success bg-opacity-25"
}
const _hoisted_44 = { class: "border text-center" }
const _hoisted_45 = {
  key: 1,
  class: "form-control form-control-solid w-100px py-1 border"
}
const _hoisted_46 = { class: "border text-center" }
const _hoisted_47 = {
  key: 1,
  class: "form-control form-control-solid w-100px py-1 border"
}
const _hoisted_48 = { class: "border bg-success bg-opacity-10 text-center" }
const _hoisted_49 = { class: "bg-success bg-opacity-75 fw-bolder text-center" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("td", {
  class: "border text-end",
  colspan: "2"
}, [
  /*#__PURE__*/_createElementVNode("h6", { class: "" }, "Total de oficiales de la delegación")
], -1)
const _hoisted_51 = { class: "border" }
const _hoisted_52 = { class: "border" }
const _hoisted_53 = { class: "border" }
const _hoisted_54 = { class: "bg-success bg-opacity-75 fw-bolder text-center" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("td", {
  class: "border text-end",
  colspan: "2"
}, [
  /*#__PURE__*/_createElementVNode("h6", { class: "" }, "Total de oficiales")
], -1)
const _hoisted_56 = { class: "border" }
const _hoisted_57 = { class: "border" }
const _hoisted_58 = { class: "border" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        ref: "formQRef",
        model: _ctx.formQ,
        rules: _ctx.rules
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.t("qtitle1")), 1)
            ])
          ]),
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("tr", _hoisted_7, [
              _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.t("sports")), 1),
              _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.t("categorie")), 1),
              _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.t("male")), 1),
              _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.t("female")), 1),
              _hoisted_12
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listItems.sports, (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: `lst-${index}-a`
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.events, (mela, index2) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: `mel${index2}s`
                    }, [
                      (index2 === 0)
                        ? (_openBlock(), _createElementBlock("td", {
                            key: 0,
                            class: "border text-center fw-bolder",
                            rowspan: item.events.length
                          }, _toDisplayString(item.name), 9, _hoisted_13))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", _hoisted_14, _toDisplayString(mela.name), 1),
                      _createElementVNode("td", _hoisted_15, [
                        (_ctx.formQ.mstatus == 0)
                          ? (_openBlock(), _createBlock(_component_el_input, {
                              key: 0,
                              modelValue: mela.male,
                              "onUpdate:modelValue": ($event: any) => ((mela.male) = $event),
                              modelModifiers: { number: true },
                              placeholder: "0",
                              class: "w-100px input-total",
                              disabled: (item.gender == '1' || item.gender == '3') ? false : true,
                              onFocus: _ctx.handleFocus,
                              onBlur: (event) => _ctx.handleBlur(event, mela, 'female', mela.vmin, mela.vmax),
                              maxlength: "2"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onFocus", "onBlur"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(mela.male), 1))
                      ]),
                      _createElementVNode("td", _hoisted_17, [
                        (_ctx.formQ.mstatus == 0)
                          ? (_openBlock(), _createBlock(_component_el_input, {
                              key: 0,
                              modelValue: mela.female,
                              "onUpdate:modelValue": ($event: any) => ((mela.female) = $event),
                              modelModifiers: { number: true },
                              placeholder: "0",
                              class: "w-100px input-total text-center",
                              disabled: (item.gender == '2' || item.gender == '3') ? false : true,
                              onFocus: _ctx.handleFocus,
                              onBlur: (event) => _ctx.handleBlur(event, mela, 'female', mela.vmin, mela.vmax),
                              maxlength: "2"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onFocus", "onBlur"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(mela.female), 1))
                      ]),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.calculateTotal(mela.male, mela.female)), 1)
                    ]))
                  }), 128))
                ], 64))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("h3", _hoisted_22, _toDisplayString(_ctx.t("qtitle2")) + "​", 1)
            ])
          ]),
          _createElementVNode("table", _hoisted_23, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_24, [
                _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.t("sports")), 1),
                _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.t("bygender")), 1)
              ]),
              _createElementVNode("tr", _hoisted_27, [
                _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.t("male")), 1),
                _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.t("female")), 1),
                _hoisted_30
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listItems.sports, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: `lst-${index}-f`
                }, [
                  (index === 0)
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 0,
                        class: "border text-center bg-success bg-opacity-10 fw-bolder",
                        rowspan: _ctx.listItems.sports.length
                      }, " Oficiales deportivos", 8, _hoisted_31))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", _hoisted_32, _toDisplayString(item.name), 1),
                  _createElementVNode("td", _hoisted_33, [
                    (_ctx.formQ.mstatus == 0)
                      ? (_openBlock(), _createBlock(_component_el_input, {
                          key: 0,
                          modelValue: item.otMen,
                          "onUpdate:modelValue": ($event: any) => ((item.otMen) = $event),
                          modelModifiers: { number: true },
                          placeholder: "0",
                          onFocus: _ctx.handleFocus,
                          onBlur: (event) => _ctx.handleBlurOf(event, item, 'otMen', item.allowed, item.otWomen),
                          class: "input-total text-center w-100px",
                          maxlength: "2"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(item.otMen), 1))
                  ]),
                  _createElementVNode("td", _hoisted_35, [
                    (_ctx.formQ.mstatus == 0)
                      ? (_openBlock(), _createBlock(_component_el_input, {
                          key: 0,
                          modelValue: item.otWomen,
                          "onUpdate:modelValue": ($event: any) => ((item.otWomen) = $event),
                          modelModifiers: { number: true },
                          placeholder: "0",
                          onFocus: _ctx.handleFocus,
                          onBlur: (event) => _ctx.handleBlurOf(event, item, 'otWomen', item.allowed, item.otMen),
                          class: "input-total text-center w-100px",
                          maxlength: "2"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(item.otWomen), 1))
                  ]),
                  _createElementVNode("td", _hoisted_37, _toDisplayString(_ctx.calculateTotal(item.otMen, item.otWomen)), 1)
                ]))
              }), 128)),
              _createElementVNode("tr", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("td", _hoisted_40, _toDisplayString(_ctx.otMen), 1),
                _createElementVNode("td", _hoisted_41, _toDisplayString(_ctx.otWomen), 1),
                _createElementVNode("td", _hoisted_42, _toDisplayString(_ctx.totalOT()), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listItems.officers, (ofi, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: `lst-${index}-of`
                }, [
                  _createElementVNode("td", _hoisted_43, _toDisplayString(ofi.name), 1),
                  _createElementVNode("td", _hoisted_44, [
                    (_ctx.formQ.mstatus == 0)
                      ? (_openBlock(), _createBlock(_component_el_input, {
                          key: 0,
                          modelValue: ofi.men,
                          "onUpdate:modelValue": ($event: any) => ((ofi.men) = $event),
                          modelModifiers: { number: true },
                          placeholder: "0",
                          onFocus: _ctx.handleFocus,
                          onBlur: (event) => _ctx.handleBlurOf(event, ofi, 'men', ofi.allowed, ofi.women),
                          class: "input-total text-center w-100px",
                          maxlength: "2"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(ofi.men), 1))
                  ]),
                  _createElementVNode("td", _hoisted_46, [
                    (_ctx.formQ.mstatus == 0)
                      ? (_openBlock(), _createBlock(_component_el_input, {
                          key: 0,
                          modelValue: ofi.women,
                          "onUpdate:modelValue": ($event: any) => ((ofi.women) = $event),
                          modelModifiers: { number: true },
                          placeholder: "0",
                          onFocus: _ctx.handleFocus,
                          onBlur: (event) => _ctx.handleBlurOf(event, ofi, 'women', ofi.allowed, ofi.men),
                          class: "input-total text-center w-100px",
                          maxlength: "2"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(ofi.women), 1))
                  ]),
                  _createElementVNode("td", _hoisted_48, _toDisplayString(_ctx.calculateTotal(ofi.men, ofi.women)), 1)
                ]))
              }), 128)),
              _createElementVNode("tr", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("td", _hoisted_51, _toDisplayString(_ctx.ofMen), 1),
                _createElementVNode("td", _hoisted_52, _toDisplayString(_ctx.ofWomen), 1),
                _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.totalOFDelegation()), 1)
              ]),
              _createElementVNode("tr", _hoisted_54, [
                _hoisted_55,
                _createElementVNode("td", _hoisted_56, _toDisplayString(_ctx.calculateTotal(_ctx.otMen, _ctx.ofMen)), 1),
                _createElementVNode("td", _hoisted_57, _toDisplayString(_ctx.calculateTotal(_ctx.otWomen, _ctx.ofWomen)), 1),
                _createElementVNode("td", _hoisted_58, _toDisplayString(_ctx.totalOT() + _ctx.totalOFDelegation()), 1)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}